<template>
	<div class="top-bar">
		<div class="top-bar__center">
			<template v-if="['essenza300', 'essenza300lt'].includes(activeProduct)">
				<button
					class="top-bar__more"
					:class="{ active: activeProduct === 'essenza300' }"
					@click="switchProduct('essenza300')"
				>
					<span>ESSENZA 300</span>
				</button>
				<button
					class="top-bar__more"
					:class="{ active: activeProduct === 'essenza300lt' }"
					@click="switchProduct('essenza300lt')"
				>
					<span>ESSENZA 300LT</span>
				</button>
			</template>
			<!-- <button class="top-bar__more" @click="openProductSelector">
				<svg><use href="#icon-plus"></use></svg>
				<span>more products</span>
			</button> -->
		</div>
	</div>
</template>

<script>
export default {
	computed: {
		activeProduct() {
			return this.$store.state.activeProduct
		}
	},
	methods: {
		openProductSelector() {
			this.$store.commit('setProductSelectorOpen', true)
			this.$store.commit('setExplanationPaneOpen', false)
		},
		switchProduct(name) {
			window.location.href = `${name}`
		}
	}
}
</script>

<style lang="scss" scoped>
.top-bar {
	top: 0;
	left: 0;
	width: 100%;
	height: 30px;
	position: absolute;
	display: flex;
	font-size: 14px;
	background-color: $clrGrey400;

	button {
		height: 100%;
		padding: 0 15px;
		position: relative;
		display: flex;
		align-items: center;
		color: $clrGrey200;
		font-weight: 500;

		&:hover {
			background-color: $clrGrey300;
			color: $clrWhite;
		}
		&:active, &.active {
			color: $clrWhite;
			background-color: $clrGrey450;
		}

		svg {
			width: 30px;
			height: 100%;
		}

		> span {
			display: inline-block;
			padding-bottom: 1px;
			margin: 0 10px;
		}

		&::after {
			content: "";
			top: 5px;
			right: 0;
			width: 1px;
			height: 20px;
			position: absolute;
			background-color: $clrGrey300;
		}

	}

	&__left {
		width: 60px;
	}

	&__center {
		display: flex;
	}

	&__more {
		svg {
		}
	}

}
</style>
